<template>
  <div>
    <b-card class="mt-5">
      <b-form v-on:submit.prevent="updateUser">
        <h3>Conferma Dati</h3>
        <!-- user detail -->

        <b-alert show variant="info" class="my-4">
          Gentile utente,<br>
          prima di proseguire è necessario confermare i dati del proprio profilo, e sostituire la password di accesso temporenea.
        </b-alert>

        <b-row>
          <b-col>
            <b-form-group
              label="Cognome" :class="{'has-danger': errors.has('last_name') }">
              <b-form-input
                v-validate data-vv-rules="alpha_spaces|required" data-vv-as="Cognome" name="last_name"
                type="text" v-model="user.last_name" required
                placeholder="Cognome"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Nome" :class="{'has-danger': errors.has('first_name') }">
              <b-form-input
                v-validate data-vv-rules="alpha_spaces|required" data-vv-as="Nome"
                name="first_name"
                type="text" v-model="user.first_name"
                placeholder="Nome"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Email" :class="{'has-danger': errors.has('email') }">
              <b-form-input
                v-validate data-vv-rules="email|required|user_unique_email" data-vv-as="Email"
                type="email" name="email" data-vv-validate-on="change" v-model="user.email"
                placeholder="La tua mail"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Numero Cellulare" :class="{'has-danger': errors.has('phone_number') }">
              <b-form-input
                v-validate data-vv-rules="phone_number|user_unique_phone_number" data-vv-delay="500"
                data-vv-as="Cellulare" name="phone_number"
                data-vv-validate-on="change" type="tel" v-model="user.phone_number"
                :formatter="phoneNumberFormatter" lazy-formatter
                placeholder="Il tuo numero"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-5" v-if="user.users_group">
          <b-col cols="6">
            <p>Gruppo di appartenza<br>
            <strong>{{ user.users_group.name }}</strong>
            </p>
          </b-col>
        </b-row>

        <h5 class="mt-3">Password accesso</h5>
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Password" :class="{'has-danger': errors.has('password') }">
              <b-form-input
                v-validate data-vv-rules="required|min:8|verify_password"
                data-vv-as="Password" name="password"
                type="password" v-model="pass.password" required
                placeholder="password"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Conferma password" :class="{'has-danger': errors.has('password_confirm') }">
              <b-form-input
                v-validate data-vv-rules="required|confirmed:password" data-vv-as="Conferma password"
                name="password_confirm"
                type="password" v-model="pass.password_confirm" required
                placeholder="Conferma password"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr>

        <b-row class="mt-3">
          <b-col class="text-right">
            <button class="btn btn-success" :disabled="errors.any()">
              <i class="fas fa-check mr-3"></i>
              <strong>Conferma i Dati</strong>
            </button>
          </b-col>
        </b-row>
      </b-form>

      <hr v-if="errors.any()">
      <div v-for="error in errors.all()">
        <b-alert show variant="danger">
          {{ error }}
        </b-alert>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters, mapMutations} from 'vuex';

  const PNF = require('google-libphonenumber').PhoneNumberFormat;
  const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
  import {UPDATE_USER} from '@/store/mutationTypes';


  export default {
    name: 'Conferma',
    data: () => ({
      pass: {
        password: null,
        confirm: null,
      },
    }),

    computed: {
      ...mapState({
        user: state => state.user,
      }),
      ...mapGetters([
        'isAdmin',
        'isProfileConfirmed'
      ])
    },

    mounted() {
      this.getData();
    },

    methods: {
      ...mapActions([
        'getProfile',
      ]),

      ...mapMutations({
        saveUserData: UPDATE_USER,
      }),

      async getData() {
        const loader = this.$loading.show();
        try {
          await Promise.all([
            this.getProfile(),
          ]);

          loader.hide();
        } catch (err) {
          loader.hide();
          this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');
        }
      },

      phoneNumberFormatter(value, event) {
        const phoneNumber = phoneUtil.parse(value, 'IT');
        const formatted = phoneUtil.format(phoneNumber, PNF.E164);
        return formatted;
      },

      async updateUser() {
        await this.$validator.validateAll();

        if (this.errors.any()) {
          return;
        }

        try {
          const data = await this.$apiclient.updateProfile({
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
            phone_number: this.user.phone_number,
            ...this.pass,
          });

          this.saveUserData(data, null);
          this.$router.push('/area-riservata/piani');
        } catch (err) {
          console.log(err);
          this.$toastr.warning('Si è verificato un errore nel caricamento dei dati.');
        }
      },

      resetProfile() {
        this.getProfile();
        this.$validator.reset('profile');
      },
    },
  };

</script>

<style scoped>
  .card {
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/pages/AreaRiservata/Conferma.vue